import {Editor} from "@tinymce/tinymce-react";
import ReactList from 'react-list';
import {useRef} from "react";
import PropTypes from "prop-types";

export function CustomEditor(props) {
    const {disableToolbar, fieldName, height, onEditorChange, initText} = props
    const editorRef = useRef(null);

    return <>
        <Editor
            onInit={(evt, editor) => editorRef.current = editor}
            onChange={(e, editor) => onEditorChange(editor, fieldName)}

            initialValue={initText ? initText : ""}
            init={!disableToolbar ? {
                height: height ? height : 500,
                menubar: true,
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'undo redo | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                promotion: false
            } : {
                height: height ? height : 500,
                toolbar: false,
                menubar: false,
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                promotion: false
            }}
        />
    </>
}

CustomEditor.propTypes = {
    isDescription: PropTypes.bool,
    height: PropTypes.number,
    onEditorChange: PropTypes.func,
    initText: PropTypes.string
}


